import { ButtonModule } from 'primeng/button';
import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PaymentService } from '../../../services/payment.service';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../../theme.service';
import { LoaderComponent } from "../../../utils/loader/loader.component";
import { DatepickerComponent } from "../../../utils/datepicker/datepicker.component";
import { CustomTableComponent } from "../../../utils/custom-table/custom-table.component";
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-complements',
    imports: [ButtonModule, LoaderComponent, DatepickerComponent, CustomTableComponent, FormsModule ],
    templateUrl: './complements.component.html',
    styleUrl: './complements.component.scss'
})
export class ComplementsComponent {
  loading = false;
  movements: any[] = [];
  reporterURL = environment.wrUrl;
  allCards: any = [];
  totalAmountForm = 0;
  paymentService = 2;
  headers: any[] = [
    { key: "date", textHeader: "Emisión", visible: true, type: "date" },
    { key: "dueDate", textHeader: "Vencimiento", visible: true, type: "date" },
    { key: "serieFolio", textHeader: "Factura", visible: true, type: "string" },
    { key: "amount", textHeader: "Importe", visible: true, type: "currency" }
    


  ];

  tableButtons = [
    {
      text: 'Factura',
      action: (event: any) => this.downloadInvoice(event, 'pdf'),
      icon: File,
      hasIcon: false,
      color: "",
      showText: true,
    },
    {
      text: 'XML',
      action: (event: any) => this.downloadInvoice(event, 'xml'),
      icon: File,
      hasIcon: false,
      color: "",
      showText: true,
    }

  ];



  fromDate!: Date;
  toDate!: Date;
  fromDateRequest!: Date;
  toDateRequest!: Date;
  selectedCard = -1;
  data: any;
  tokenAuth: any;

  ngOnInit() {
      let today = new Date();
      this.fromDate = new Date(today.getFullYear(), today.getMonth() - 6, today.getDate());
      this.toDate = today;
     
    }
    constructor(private service: PaymentService, private titleService:Title,private themeService:ThemeService
      
    ) {
      this.titleService.setTitle("Complementos de Pago");
      this.themeService.setTitle("Complementos de Pago");
     
      this.data = JSON.parse(localStorage.getItem('data')!); 
    }
    ngAfterViewInit(): void {
       this.getMovements();
    }
  
    setDatesOnFilter(event: any) {
      this.fromDate = event.from;
      this.toDate = event.to;
    }
  
    changeDeviceFilter(event: any, isFromCard: boolean) {
      this.selectedCard = event.value;
    }
  
  
  
  
  
    getMovements() {
      this.loading = true;
      this.fromDateRequest = new Date(this.fromDate);
      this.toDateRequest = new Date(this.toDate);
  
      this.service.getPaymentVouchers(this.data.Client_id, this.fromDateRequest, this.toDateRequest).subscribe({
        next: (resp: any) => {
  
          

          this.movements = resp;
  
  
          this.loading = false;
        },
        error: (err: any) => {
          this.movements = [];
          this.loading = false;
        }
      });
    }
  
  
  
    downloadInvoice(data: any,type:string) {
      let url ='';
     if(type=='pdf'){
      
        url = this.reporterURL+'pdf/MonederoXiga.aspx?rptId=data&rptName=rpt_paymentInvoiceSingle&invoiceId='+data.paymentVoucherId+'&DataServer=NexusFEMonedero&fileName=rpt_paymentInvoiceSingleV3&langId=2';
     }else{
    

      url = this.reporterURL+'pdf/MonederoXiga.aspx?rptId=xml&invoiceId='+data.paymentVoucherId;
     }
  
 
  window.open(url, "_blank");
    }
  
    download(id:string){
      let url=''; 
      let fromDateString = (this.fromDateRequest.getMonth()+1).toString().padStart(2,"0").substring(0,2)+'/'+(this.fromDateRequest.getDate().toString().padStart(2,"0")).substring(0,2)+'/' + this.fromDateRequest.getFullYear()
      let toDateString =(this.toDateRequest.getMonth()+1).toString().padStart(2,"0").substring(0,2)+'/'+(this.toDateRequest.getDate().toString().padStart(2,"0")).substring(0,2)+'/' + this.toDateRequest.getFullYear()
      if(id=="1"){
         
        url = this.reporterURL+'Excel/MonederoXiga.aspx?rptName=payments&clientStart='+this.data.Client_number+'&clientEnd='+this.data.Client_number+'&contableDate='+ fromDateString+'&toContableDate='+toDateString+'&prefix=0&isReport=1';
      }else if(id=="2"){
       
        url = this.reporterURL+'pdf/MonederoXiga.aspx?rptId=data&rptName=rpt_Payments&FromDate='+ fromDateString+'&ToDate='+toDateString+'&clientStart='+this.data.Client_number;
      }
      window.open(url, "_blank");
    }
}
